import React, { Component } from 'react';
import apiHandler from '../../../utilities/apiHandler';
import '../APKs.css';

const APP_TENANT_NAME = 'BRADMAN';

function getApiErrorMessage(error, fallback) {
    if (error && error.error && error.error.error) return error.error.error;
    if (error && error.message) return error.message;
    return fallback;
}

function getDownloadUrl(response) {
    if (typeof response === 'string') return response;
    return response && (response.data || response.url || response.presignedUrl);
}

function isSafeUrl(url) {
    return typeof url === 'string' && /^https?:\/\//i.test(url);
}

class APKs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            version: '',
            versionError: null,
            apiResponse: null,
            apiError: null,
            isLoading: false,
            availableVersions: [],
            isLoadingVersions: true,
            versionsError: null,
        };
    }

    componentDidMount() {
        this.fetchAvailableVersions();
    }

    fetchAvailableVersions = () => {
        this.setState({ isLoadingVersions: true, versionsError: null });

        apiHandler
            .getAppVersions(APP_TENANT_NAME)
            .then((response) => {
                const versions = response.data || response.versions || response || [];
                this.setState({
                    availableVersions: Array.isArray(versions) ? versions : [],
                    isLoadingVersions: false,
                    versionsError: null,
                });
            })
            .catch((error) => {
                console.error('Failed to fetch versions:', error);
                this.setState({
                    versionsError: getApiErrorMessage(error, 'Failed to load available versions'),
                    isLoadingVersions: false,
                    availableVersions: [],
                });
            });
    };

    handleVersionChange = (e) => {
        const value = e.target.value;
        this.setState({ 
            version: value, 
            versionError: null,
            apiError: null,
            apiResponse: null
        });
    };

    handleSubmit = () => {
        const { version } = this.state;

        // Validation
        if (!version) {
            this.setState({ versionError: 'Please select a version' });
            return;
        }
 
        this.downloadVersion(version);
    };

    downloadVersion = (version) => {
        this.setState({ isLoading: true, apiError: null, apiResponse: null });

        apiHandler
            .getAppRelease(APP_TENANT_NAME, version)
            .then((response) => {
                const downloadUrl = getDownloadUrl(response);
                if (downloadUrl && isSafeUrl(downloadUrl)) {
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                this.setState({
                    apiResponse: typeof response === 'string' ? { data: response } : response,
                    isLoading: false,
                    apiError: null,
                });
            })
            .catch((error) => {
                console.error('APK Download Failed:', error);
                this.setState({
                    apiError: getApiErrorMessage(error, 'Failed to download APK version'),
                    isLoading: false,
                    apiResponse: null,
                });
            });
    };

    render() {
        const { version, versionError, apiResponse, apiError, isLoading, availableVersions, isLoadingVersions, versionsError } = this.state;

        return (
            <div className="apk-container">
                <div className="apk-header">
                    <h2 className="apk-title">APK Download Manager</h2>
                    <p className="apk-subtitle">Download BRADMAN APK by version</p>
                </div>

                <div className="apk-content">
                    <div className="apk-form-section">
                        {versionsError && (
                            <div className="apk-error-message apk-versions-error-row">
                                <i className="fas fa-exclamation-circle"></i> {versionsError}
                                <button
                                    type="button"
                                    className="apk-retry-btn"
                                    onClick={this.fetchAvailableVersions}
                                >
                                    Retry
                                </button>
                            </div>
                        )}
                        
                        <div className="apk-form-group">
                            <label htmlFor="apk-version-select" className="apk-label">
                                Version Number <span className="apk-required">*</span>
                            </label>
                            <select
                                id="apk-version-select"
                                value={version}
                                onChange={this.handleVersionChange}
                                className={`apk-select ${versionError ? 'apk-input-error' : ''}`}
                                disabled={isLoading || isLoadingVersions}
                            >
                                <option value="">
                                    {isLoadingVersions ? 'Loading versions...' : 'Select a version'}
                                </option>
                                {availableVersions.map((ver) => (
                                    <option key={ver} value={ver}>
                                        {ver}
                                    </option>
                                ))}
                            </select>
                            <p className="apk-input-hint">
                                {isLoadingVersions ? 
                                    'Fetching available versions...' : 
                                    `${availableVersions.length} version(s) available`
                                }
                            </p>
                            {versionError && (
                                <div className="apk-error-message">
                                    <i className="fas fa-exclamation-circle"></i> {versionError}
                                </div>
                            )}
                        </div>

                        <div className="apk-form-actions">
                            <button
                                type="button"
                                className="apk-submit-btn"
                                onClick={this.handleSubmit}
                                disabled={isLoading || isLoadingVersions || !version}
                            >
                                {isLoading ? (
                                    <React.Fragment>
                                        <i className="fas fa-spinner fa-spin"></i> Downloading...
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <i className="fas fa-download"></i> Download APK
                                    </React.Fragment>
                                )}
                            </button>
                        </div>
                    </div>

                    {apiResponse && (
                        <div className="apk-success-box">
                            <div className="apk-success-icon">
                                <i className="fas fa-check-circle"></i>
                            </div>
                            <div className="apk-success-content">
                                <h3 className="apk-success-title">APK Download Ready!</h3>
                                <p className="apk-success-message">
                                    BRADMAN APK download has started. If it did not start, click the link below.
                                </p>
                                {apiResponse.data && isSafeUrl(apiResponse.data) && (
                                    <a
                                        href={apiResponse.data}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="apk-download-link-btn"
                                    >
                                        <i className="fas fa-download"></i> Download APK again
                                    </a>
                                )}
                                {apiResponse.message && (
                                    <div className="apk-response-details">
                                        <strong>Details:</strong> {apiResponse.message}
                                    </div>
                                )}
                                {apiResponse.data && typeof apiResponse.data === 'object' && (
                                    <div className="apk-response-data">
                                        <pre>{JSON.stringify(apiResponse.data, null, 2)}</pre>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {apiError && (
                        <div className="apk-error-box">
                            <div className="apk-error-icon">
                                <i className="fas fa-times-circle"></i>
                            </div>
                            <div className="apk-error-content">
                                <h3 className="apk-error-title">Download Failed</h3>
                                <p className="apk-error-text">{apiError}</p>
                            </div>
                        </div>
                    )}

                    <div className="apk-info-section">
                        <div className="apk-info-card">
                            <i className="fas fa-info-circle apk-info-icon"></i>
                            <div>
                                <h4 className="apk-info-title">Download Information</h4>
                                <ul className="apk-info-list">
                                    <li>App Name: <strong>BRADMAN</strong></li>
                                    <li>Select a version from the dropdown menu</li>
                                    <li>Available versions are automatically fetched from the server</li>
                                    <li>Click "Download APK" to get the selected version</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default APKs;



// WEBPACK FOOTER //
// ./src/screens/APKs/Components/APKs.js